import React from 'react';
import { Button, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import DropdownWithUpsell from '~components/DropdownWithUpsell';
import useRevisitIntervalOptions, { type RevisitIntervalOption } from '../useRevisitIntervalOptions';
import { useUpgradePlan } from '~features/UpgradePlan';
import RevisitIntervalFooter from './RevisitIntervalFooter';

type RevisitIntervalTableDropdownProps = {
  selectedOptionKey: string;
  selectedOptionLabel: string;
  onOptionSelected: (option: RevisitIntervalOption) => void;
};

function RevisitIntervalTableDropdown({
  selectedOptionKey,
  selectedOptionLabel,
  onOptionSelected,
}: RevisitIntervalTableDropdownProps) {
  const { openUpgradePlan } = useUpgradePlan();
  const options = useRevisitIntervalOptions();

  return (
    <DropdownWithUpsell
      footerElement={<RevisitIntervalFooter />}
      selectedKey={selectedOptionKey}
      options={options}
      onOptionSelected={onOptionSelected}
      onUpsellClicked={(option) =>
        openUpgradePlan('sitemaps', option.upsellPlanId, {
          ctaLocation: 'Sitemaps Table - Revisit Interval Dropdown',
          ctaName: 'Upgrade',
        })
      }
    >
      <Button type="link" size="small">
        <Space>
          {selectedOptionLabel}
          <DownOutlined />
        </Space>
      </Button>
    </DropdownWithUpsell>
  );
}

export default RevisitIntervalTableDropdown;
